"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _MaskedInput = _interopRequireDefault(require("../masked-input/MaskedInput"));

var _excluded = ["allowDecimals", "max", "min"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var createMaskOptions = function createMaskOptions(_ref) {
  var allowDecimals = _ref.allowDecimals,
      max = _ref.max,
      min = _ref.min;
  return {
    max: max,
    min: min,
    mask: Number,
    padFractionalZeros: allowDecimals,
    radix: '.',
    scale: allowDecimals ? 2 : 0,
    thousandsSeparator: ','
  };
};

var adornmentStyles = {
  pointerEvents: 'none'
};

function CurrencyInput(props) {
  var allowDecimals = props.allowDecimals,
      max = props.max,
      min = props.min,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);

  var _useState = (0, _react.useState)(function () {
    return createMaskOptions({
      allowDecimals: allowDecimals,
      max: max,
      min: min
    });
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      maskOptions = _useState2[0],
      setMaskOptions = _useState2[1];

  (0, _react.useEffect)(function () {
    setMaskOptions(createMaskOptions({
      allowDecimals: allowDecimals,
      max: max,
      min: min
    }));
  }, [allowDecimals, max, min]);
  return /*#__PURE__*/_react.default.createElement(_MaskedInput.default, Object.assign({}, otherProps, {
    inputMode: "decimal",
    startAdornment: /*#__PURE__*/_react.default.createElement("span", {
      style: adornmentStyles
    }, "$"),
    maskOptions: maskOptions
  }));
}

CurrencyInput.defaultProps = {
  allowDecimals: false
};
CurrencyInput.propTypes = {
  /**
   * If `true` the user will be able to enter decimals as part of the value
   * and in case no decimals are entered by default a .00 will be appended
   * when the focus is lost.
   *
   *  If `false` only the integer part can be entered.
   */
  allowDecimals: _propTypes.bool,

  /**
   * The maximum value that can be entered into the Input.
   */
  max: _propTypes.number,

  /**
   * The minimum value that can be entered into the Input.
   *
   * It __must be a positive number__, it does not accept negatives.
   */
  min: _propTypes.number
};
var _default = CurrencyInput;
exports.default = _default;
